<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="relative w-full overflow-x-auto overflow-y-hidden rounded border border-solid border-gray-400"
  >
    <table class="w-full text-left">
      <thead class="border-b border-solid border-gray-400 bg-gray-100">
        <tr>
          <th class="w-52 px-5 py-3">
            <span class="font-bold">{{ t('plan-name') }}</span>
          </th>
          <th class="px-5 py-3">
            <span class="font-bold">{{ t('details') }}</span>
          </th>
          <th class="w-52 px-5 py-3">
            <span class="font-bold">{{ t('price') }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in pricePlanData.plans"
          :key="hash(item)"
          class="border-b border-solid border-gray-400 last:border-b-0"
          :class="
            item.billingCycleId === EnumBillingCycle.FREE_TRIAL &&
            'bg-yellow-400/10'
          "
        >
          <td class="w-64 px-5 py-3">
            <div>
              <p class="mb-1 text-2xl font-bold">{{ item.name }}</p>
              <p class="mb-1 text-sm text-gray-600">{{ item.partNumber }}</p>
              <MostPopularTag v-if="item.isMostPopular" />
            </div>
          </td>
          <td class="px-5 py-3">
            <div
              class="markdown-content"
              v-html="provideMarkdownHtml(item.description)"
            />
          </td>
          <td class="w-64 px-5 py-3">
            <AreaPricingPriceItem :plan-data="item" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import {
    EnumBillingCycle,
    EnumServiceType,
  } from '@/assets/types/api/Products';
  import MostPopularTag from '@/components/Area/Pricing/MostPopularTag.vue';
  import type { IPricePlanData } from '@/stores/pricing/pricingStore';

  interface IProps {
    pricePlanData: IPricePlanData;
  }

  withDefaults(defineProps<IProps>(), {
    pricePlanData: () => {
      return {
        tabId: EnumServiceType.CLOUD_ENSAAS,
        plans: [],
      };
    },
  });

  const { t } = useI18n({ useScope: 'local' });
</script>

<style scoped lang="scss">
  .markdown-content {
    :deep(ul),
    :deep(ol),
    :deep(p),
    :deep(a) {
      @apply text-black;
    }
  }
</style>

<i18n lang="json">
{
  "en-int": {
    "plan-name": "Plan name",
    "details": "Details",
    "price": "Price"
  },
  "en-jp": {
    "plan-name": "Plan name",
    "details": "Details",
    "price": "Price"
  },
  "en-tw": {
    "plan-name": "Plan name",
    "details": "Details",
    "price": "Price"
  },
  "en-kr": {
    "plan-name": "Plan name",
    "details": "Details",
    "price": "Price"
  },
  "en-americas": {
    "plan-name": "Plan name",
    "details": "Details",
    "price": "Price"
  },
  "en-asia-pacific": {
    "plan-name": "Plan name",
    "details": "Details",
    "price": "Price"
  },
  "en-emea": {
    "plan-name": "Plan name",
    "details": "Details",
    "price": "Price"
  },
  "ja-jp": {
    "plan-name": "プラン名",
    "details": "詳細",
    "price": "価格"
  },
  "zh-cn": {
    "plan-name": "方案名称",
    "details": "详细信息",
    "price": "价格"
  },
  "zh-tw": {
    "plan-name": "方案名稱",
    "details": "細節",
    "price": "價格"
  }
}
</i18n>
